import React from 'react';
import PropTypes from 'prop-types';

import Input from '../Input';

export default function CheckBox(props) {
  const inputProps = Object.assign({}, props);

  delete inputProps.type;

  return <Input {...inputProps} type="checkbox" />;
}

CheckBox.propTypes = {
  className: PropTypes.string,
};

CheckBox.defaultProps = {
  className: null,
};
